
import { defineComponent, ref, watch, PropType } from "vue";

export default defineComponent({
  name: "InputCheckboxGroup",
  components: {
  },
  props: {
    keyValue: {
      type: String as PropType<string>,
      required: false,
    },
    label: {
      type: String as PropType<string>,
      required: true,
    },
    value: {
      type: Array as PropType<string[]>,
      required: false,
      default: () => [],
    },
    options: {
      type: Array as PropType<string[]>,
      required: true,
    },
    required: {
      type: Boolean as PropType<boolean>,
      required: false,
    },
  },
  setup(props, { emit }) {
    const checked = ref<string[]>(props.value);

    // Watch for external value changes
    watch(
      () => props.value,
      (newValue) => {
        checked.value = newValue;
      }
    );

    // Emit changes when the value updates
    const updateValue = () => {
      emit("update", {
        key: props.keyValue || props.label,
        value: checked.value,
      });
    };

    return {
      checked,
      updateValue,
    };
  },
});
